
export const formatCorrectlyMailAdresse = (mail) => {
    const mailWithout = mail.replace(/<|>/g, '')
    return mailWithout;
  };
